export const environment = {
  production: true,
  authApiUrl: 'https://dev.dcware.app/user-management',
  apiURL: 'https://dev.dcware.app/user-management',
  baseUrl: 'https://dev.dcware.app/',
  filesApiUrl: 'https://dev.dcware.app/gcs/',
  recaptchaKey: '6Lf8wgEgAAAAAHly0j9e51Uzi6dZ5PvyqDw9O9PB',
  placesApiKey: 'AIzaSyBaKgb5XgCiSjaPg0p3-IRChjjCyE94LQY',
};
